import React, { useEffect, useState } from 'react';
import "../styles/courseSingle.css";
import { BiHomeAlt2 } from "react-icons/bi";
import { TbPointFilled } from "react-icons/tb";
import {
  FaClock,
  FaChartBar,
  FaGlobe,
  FaCertificate,
} from 'react-icons/fa';
import coach from "../images/kahenya/p2.jpeg"
import { TfiBlackboard } from "react-icons/tfi";
import { IoCopy } from "react-icons/io5";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { getACourse } from "../features/courses/courseSlice";
import BookingOverlay from '../components/BookingOverlay';
import { createCourseRequest } from '../features/courseRequests/courseRequestSlice';
import SingleCourseLoader from '../components/SingleCourseLoader';
import { FaWhatsapp } from "react-icons/fa";
import Meta from '../components/Meta';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
 import loader from "../images/loader/loader1.jpg";

const CourseSinglePage = () => {
  const dispatch = useDispatch();

  const { id } = useParams();
  const singleCourse = useSelector((state) => state.course.singleCourse);
  const [showOverlay, setShowOverlay] = useState(false);
    console.log(showOverlay)
  useEffect(() => {
    dispatch(getACourse(id));
  }, [dispatch, id]);

  const [loading, setLoading] = useState(false);


    const [requestSuccess, setRequestSuccess] = useState(false);
   
   
     const { isSuccess, isError, message, isLoading } = useSelector((state) => state.courseRequest);
   
   
     useEffect(() => {
       if (isSuccess) {
         toast.success("Booking Created successfully!");
    
         setRequestSuccess(true);
   
       }
     
       if (isError) {
         toast.error(message || "Something went wrong!");
       }
     }, [isSuccess, isError, message, dispatch]);   
  

   const [contactDetails, setContactDetails] = useState({
      name: "",
      email: "",
      phone: "",
      
      contactMethod: "",  
    });

    const handleContactChange = (e) => {
      const { name, value } = e.target;
      setContactDetails((prev) => ({ ...prev, [name]: value }));
    };
    
    const handleSubmit = (e) => {
      e.preventDefault();
      setLoading(true);

      const requestData = {
        contactDetails: {
          name: contactDetails.name,
          email: contactDetails.email,
          phone: contactDetails.phone,
          contactMethod: contactDetails.contactMethod,
        },
        course: {
          id: singleCourse._id,
          title: singleCourse.title,
          price: singleCourse.price,
          duration: singleCourse.duration,
        }
      };

      console.log(requestData,"requestdata")
      
        dispatch(createCourseRequest(requestData));
    };
    

  const copyToClipboard = (text) => {
    const textField = document.createElement("textarea");
    textField.value = text;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
    toast.info("Course link copied to clipboard!");
  };

  if (!singleCourse) return <SingleCourseLoader/>;

  return (
    <>
    <Meta title={singleCourse.title}/>
       <div className='single-course-wrapper'>
      <div className='single-course-header'>
        <div className='course-breadcrumb'>
          <Link to='/'><BiHomeAlt2 className='course-icon' /></Link> |
          <Link to='/courses'>Courses</Link> |
          <span>{singleCourse.title}</span>
        </div>

        <div className='single-course-el'>
          <h3>{singleCourse.title}</h3>
          <div className='single-couch-details'>
            <div className='coach-profile'>
          <LazyLoadImage
            alt='Qentrain Solutions'
            effect="blur"
            src={coach || loader}
            placeholderSrc={loader}
            width="60px"
            height="60px"
            className="img-fluid mx-auto img-el"
          />
            </div>
            <div className='single-couch-name'>
              <span>Lecturer</span>
              <h4>{singleCourse.lecturer}</h4>
            </div>
            <div className='single-couch-category'>
              <span>Category</span>
              <h4>{singleCourse.category}</h4>
            </div>
            <div className='single-couch-duration'>
              <span>Duration</span>
              <h4>{singleCourse.duration}</h4>
            </div>
          </div>
        </div>
      </div>

      <div className='single-course-info'>
        <div className='single-course-info-container'>
          <h5>About Course</h5>
          <div className='course-hr'></div>
          <div
      className="course-description"
      dangerouslySetInnerHTML={{ __html: singleCourse.description }}
    />

    <h5>What Will You learn</h5>
    <div
      className="course-learnings"
      dangerouslySetInnerHTML={{ __html: singleCourse.whatYouWillEarn?.[0] }}
    />
        </div>

        <div className="course-booking-button">
          <h3>KES {singleCourse.price.toLocaleString()}</h3>
          <div className="single-course-button">
            <button onClick={()=> setShowOverlay(true)}>Request Call</button>
          </div>
             <div className="single-course-whatsapp-button">
        <button
          className="border-0"
          onClick={() => {
            const businessName = "Qentrain Solutions Ltd";
            const productTitle = singleCourse?.title || 'N/A';
            const productPrice = singleCourse?.price || 'N/A';
            const productUrl = `https://qentrainsolutions.onrender.com/course/${singleCourse?._id}`;

            const message = encodeURIComponent(
              `Hello ${businessName},\n\nI'm interested in enrolling in the course "${productTitle}".\n\nPrice: KES ${productPrice.toLocaleString()}\nCourse Link: ${productUrl}\n\nPlease share more details on how to proceed.\n\nThank you.`
            );

            const phoneNumber = "254720350903";
            const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

            window.open(whatsappUrl, '_blank');
          }}
        >
          <FaWhatsapp className="whatsapp-icon" /> Enquire on WhatsApp
        </button>


          </div>

          <h4>This course includes:</h4>

          <div className="info-item">
            <div><TfiBlackboard className="icon" /> Lectures</div>
            <span className="info-value">{singleCourse.lectures || "N/A"}</span>
          </div>
          <div className="info-item">
            <div><FaClock className="icon" /> Duration</div>
            <span className="info-value">{singleCourse.duration}</span>
          </div>
          <div className="info-item">
            <div><FaChartBar className="icon" /> Skill Level</div>
            <span className="info-value">{singleCourse.skillLevel || "All Levels"}</span>
          </div>
          <div className="info-item">
            <div><FaGlobe className="icon" /> Language</div>
            <span className="info-value">{singleCourse.language || "English"}</span>
          </div>
          <div className="info-item">
            <div><FaCertificate className="icon" /> Certificate</div>
            <span className="info-value">{singleCourse.certificate ? "Yes" : "No"}</span>
          </div>
          <div className="info-item">
            <IoCopy className="icon" />
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                copyToClipboard(window.location.href);
              }}
              style={{ cursor: "pointer", textDecoration: "underline" }}
            >
              Copy Course Link
            </a>
          </div>
        </div>
      </div>

      <BookingOverlay
      isOpen={showOverlay}
      loading={loading}
      onClose={() => setShowOverlay(false)}
      contactDetails={contactDetails}
      handleChange={handleContactChange}
      handleSubmit={handleSubmit}
      requestSuccess={requestSuccess}
    />

 
    </div>
    </>
 
  );
};

export default CourseSinglePage;
